export default "__VITE_ASSET__CmnCJ0KQ__"